// extracted by mini-css-extract-plugin
export default {"Master":"semilleros_Master__2Q6qO","Fotos":"semilleros_Fotos__ys6oy","FotoMedios":"semilleros_FotoMedios__DZqrl","FotoImgMedios":"semilleros_FotoImgMedios__WJ9gb"};